export const Breakpoint = {
    MD: 900, // this value is base on @include tablet
};
